import React from 'react';

import { Stack, Switch, Typography } from '@mui/material';
import { Controller } from 'react-hook-form';

import type { DefecationCategoryType } from '@/types/domain/defecation/valueObjects/defecationCategory';
import type { Control } from 'react-hook-form';

import SelectFieldComp from '@/components/SelectFieldComp';
import TimeFieldComp from '@/components/TimeFieldComp';
import { MeasureDateTime } from '@/domain/defecation/service/entity/valueObjects/measureDateTime';
import { DEFECATION_CATEGORY_TYPE } from '@/types/domain/defecation/valueObjects/defecationCategory';

/**
 * DefecationInputType
 */
export type DefecationInputType = {
  /** 昨日で登録 */
  isYesterday: boolean,
  /** defecationCategory */
  defecationCategory: DefecationCategoryType,
  /** measureDateTime */
  measureDateTime: string,
}

/**
 * DefecationFormInputType
 */
export type DefecationFormInputType = {
  /** コントロール */
  control: Control<DefecationInputType, never>,
  /** エラー */
  errors: any,
}

const DefecationFormInput: React.FC<DefecationFormInputType> = ({
  control,
  errors,
}) => (
  <div>
    <div style={{ margin: '10px 0' }}>
      <Controller
        render={({ field }) => (
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
            <Switch defaultChecked={field.value} onChange={field.onChange} />
            <Typography>昨日の排泄で登録</Typography>
          </Stack>
        )}
        name="isYesterday"
        control={control as any}
      />
    </div>
    <SelectFieldComp
      control={control}
      name="defecationCategory"
      label="種類"
      rules={{
        /** 必須 */
        required: '必須項目です',
      }}
      errors={errors}
      items={DEFECATION_CATEGORY_TYPE.map((v) => ({
        id: v,
        name: v,
      }))}
    />
    <TimeFieldComp
      control={control}
      name={MeasureDateTime.key}
      label={MeasureDateTime.label}
      rules={MeasureDateTime.validationRule}
      errors={errors}
    />
  </div>
);

export default DefecationFormInput;
